module.exports = __webpack_public_path__ + "img/eye_in_wireless_en_white.e487e302.png";